import React from "react";
import "./button.css";
import { Link } from "react-router-dom";

const ButtonLink = (props) => {
  const {
    children,

    to,
    state,

    onClick,
    type = "button",

    id,
    className = "",

    size = "md",
    variant = "primary",
    disabled = false,

    width,
    padding,

    loading = false,
    ...rest
  } = props;

  return (
    <Link
      to={to}
      state={state}
      id={id}
      type={type}
      className={`global-button global-button--${variant} global-button--${size} ${className} ${
        disabled || loading ? "disabled" : ""
      }`}
      onClick={onClick}
      style={{
        width,
        padding,

        pointerEvents: disabled || loading ? "none" : "auto",
      }}
      {...rest}
    >
      {loading ? <span className="button-spinner"></span> : children}
    </Link>
  );
};

export default ButtonLink;
